// "John Doe"            -> "John D"
// "John"                -> "John"
// "John Michael Doe"    -> "John D"   (last token is the surname)
// ""/null/undefined     -> ""
export function shortName(name) {
  if (!name) return '';
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '';
  if (parts.length === 1) return parts[0];
  const first = parts[0];
  const lastInitial = parts[parts.length - 1][0]?.toUpperCase();
  return lastInitial ? `${first} ${lastInitial}` : first;
}
